import React, { useState } from 'react';
import styled from '@emotion/styled';
import { MYSTIC, SUBMARINE } from '@constants';
import ArrowDownIcon from '@assets/icons/ArrowDown';
import { theme } from '@styles';

const { breakpoints } = theme;

export type FAQProps = {
  question: string;
  answer: string;
};

type Props = {
  items: FAQProps[];
};

const FAQ: React.FC<Props> = ({ items }) => {
  const [openedQuestion, setOpenedQuestion] = useState<null | number>(null);

  const handleFaqClick = (index: number) => {
    if (openedQuestion === index) {
      setOpenedQuestion(null);
    } else {
      setOpenedQuestion(index);
    }
  };

  return (
    <Wrapper>
      {items.map((item, index) => {
        const isHidden = openedQuestion !== index;
        return (
          <FAQWrapper key={index}>
            <Item>
              <QuestionWrapper onClick={() => handleFaqClick(index)}>
                <Question>{item.question}</Question>
                <Icon positionUp={!isHidden}>
                  <ArrowDownIcon stroke={SUBMARINE} strokeWidth={2} />
                </Icon>
              </QuestionWrapper>
              <Answer hidden={isHidden} dangerouslySetInnerHTML={{ __html: item.answer }} />
            </Item>
          </FAQWrapper>
        );
      })}
    </Wrapper>
  );
};

export default FAQ;

const Icon = styled.div<{ positionUp: boolean }>`
  transform: ${({ positionUp }) => (positionUp ? 'rotate(180deg)' : '')};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

const QuestionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
  user-select: none;
  padding: 15px 24px;
  &:hover {
    opacity: 0.8;
  }
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    align-items: center;
  }
`;

const Answer = styled.div<{ hidden: boolean }>`
  display: ${({ hidden }) => (hidden ? 'none' : 'initial')};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  padding: 0px 24px 15px 24px;
  margin-top: -10px;
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    margin-top: -7px;
  }
`;

const Question = styled.div`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: -0.1px;
  width: 100%;
  margin-right: 8px;
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    font-size: 20px;
    line-height: 30px;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
`;

const FAQWrapper = styled.div`
  /* padding: 15px 24px; */
  &:not(:last-child) {
    border-bottom: 1px solid ${MYSTIC};
  }
`;

const Wrapper = styled.div`
  border: 1px solid ${MYSTIC};
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    border-radius: 30px;
  }
`;
